'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _getIn2.default)(['meetingsLinkUrl']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/responders/operators/getMeetingsLinkUrl.js
// module id = 1180
// module chunks = 2 3